var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#E8F0FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5094_4975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38424 29.7132C7.93572 30.1618 7.93572 30.8891 8.38424 31.3377L10.0088 32.968C10.4575 33.4166 11.1847 33.4166 11.6334 32.968L15.696 28.9089L12.4468 25.6562L8.38424 29.7132Z",
    fill: "#002953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2587 24.8442L16.5079 28.0934C17.8808 26.7204 20.2832 27.9245 23.136 28.222L13.1289 18.2148C13.4276 21.0688 14.6305 23.4724 13.2587 24.8442Z",
    fill: "#002953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3152 25.6527C34.3537 21.6707 34.3995 15.1688 30.4175 11.1304C30.4163 11.1292 30.4151 11.128 30.414 11.1268C26.4387 7.03731 19.901 6.94468 15.8115 10.9199C15.7727 10.9576 15.7344 10.9955 15.6962 11.0337C14.148 12.4663 13.2149 14.4428 13.0928 16.5486L24.8003 28.2562C26.9061 28.134 28.8826 27.2009 30.3152 25.6527Z",
    fill: "#002953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5054 34.999C33.409 34.999 34.9521 33.4558 34.9521 31.5522C34.9521 29.6486 33.409 28.1055 31.5054 28.1055C29.6018 28.1055 28.0586 29.6486 28.0586 31.5522C28.0586 33.4558 29.6018 34.999 31.5054 34.999Z",
    fill: "#002953"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5094_4975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTt);
export default __webpack_public_path__ + "static/media/TT.04228a5e6ce8d7ceebd03764686739d6.svg";
export { ForwardRef as ReactComponent };